import React from "react";
import { Flex, Text, Button } from "@chakra-ui/react";
import ServiceTypeSkeleton from "../ServiceTypeSkeleton";

interface Step3Props {
  serviceTypes: any[];
  isLoading: boolean;
  error: any;
  onSelect: (serviceType: any) => void;
}

const Step3_ServiceType: React.FC<Step3Props> = ({ serviceTypes, isLoading, error, onSelect }) => {
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" width="100%">
      <Text fontSize="lg" fontWeight="bold" mb={4}>Select your service type</Text>

      {isLoading ? (
        <ServiceTypeSkeleton/>
      ) : error ? (
        <p>Error loading service types: {error.message}</p>
      ) : (
        serviceTypes.map((serviceType) => (
          <Button
            key={serviceType.id}
            border="2px"
            borderColor="#B92F2F"
            onClick={() => onSelect(serviceType)}
            mb={3}
            maxWidth="400px"
            minWidth="320px"
            variant='outline'
            boxShadow="md"
            _hover={{ bg: "#B92F2F", color: "#fff" , borderColor:"#B92F2F"}}
          >
            {serviceType.name}
          </Button>
        ))
      )}
    </Flex>
  );
};

export default Step3_ServiceType;